import React from 'react';
import c from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, Image } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_MOBILE, SCREEN_NORMAL, SCREEN_TABLET } from '../../config/constants';
import type { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';
import SwirlIllustrations from '../SwirlIllustrations';

import './style.scss';

interface HeroImageProps {
  image: ImmutableEntity<MediaReferenceField<'image'>> & { size: number };
}

const HeroImage: React.FC<HeroImageProps> = ({ image }) => {
  const mimeType = image.get('mime_type');

  if (mimeType === 'image/svg+xml') {
    return (
      <Image
        lazyload={false}
        className="Hero__image"
        includeWebP={false}
        src={image.get('source')}
        alt={image.get('alt', '')}
      />
    );
  }

  return (
    <Image
      lazyload={false}
      className="Hero__image"
      includeWebP
      src={{
        [SCREEN_MOBILE]: image.getIn(['styles', 'hero_mobile']),
        [SCREEN_TABLET]: image.getIn(['styles', 'hero_tablet']),
        [SCREEN_NORMAL]: image.getIn(['styles', 'hero_desktop']),
      }}
      alt={image.get('alt', '')}
    />
  );
};

export interface HeroProps {
  image?: ImmutableEntity<MediaReferenceField<'image'>> & { size: number };
  className?: string;
}

const HeroInner: React.FC<Omit<HeroProps, 'className'>> = ({ image }) => {
  const classNames = c('Hero__inner');

  return (
    <div className={classNames}>
      {image && image.size > 0 && (
        <HeroImage image={image} />
      )}

      {(!image || image.size === 0) && (
        <SwirlIllustrations
          variant="hero"
        />
      )}
    </div>
  );
};

const Hero: React.FC<HeroProps> = (props) => {
  const {
    className,
    ...restProps
  } = props;

  const classNames = c('Hero', className);

  return (
    <div className={classNames}>
      <Container>
        <HeroInner {...restProps} />
      </Container>
    </div>
  );
};

export default Hero;
